/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { api } from '@/lib/api'
import type {
  ApiResponse,
  GetRegisterCodesParams,
  GetRegisterCodesResponse,
  RegisterCodeCreatePayload,
  SearchRegisterCodesParams,
} from './types'

export async function getRegisterCodes(
  params: GetRegisterCodesParams = {}
): Promise<GetRegisterCodesResponse> {
  const { p = 1, page_size = 10 } = params
  const res = await api.get(`/api/register_code/?p=${p}&page_size=${page_size}`)
  return res.data
}

export async function searchRegisterCodes(
  params: SearchRegisterCodesParams
): Promise<GetRegisterCodesResponse> {
  const { keyword = '', p = 1, page_size = 10 } = params
  const res = await api.get(
    `/api/register_code/search?keyword=${keyword}&p=${p}&page_size=${page_size}`
  )
  return res.data
}

export async function createRegisterCodes(
  data: RegisterCodeCreatePayload
): Promise<ApiResponse & { data?: string[] }> {
  const res = await api.post('/api/register_code/', data)
  return res.data
}

export async function deleteRegisterCode(id: number): Promise<ApiResponse> {
  const res = await api.delete(`/api/register_code/${id}`)
  return res.data
}
